"use client";

import React from "react";
import { SupLoader } from "@repo/core-ui";

interface SupUiLoadingProps {
  className?: string;
  isSmall?: boolean;
  svgClassName?: string;
}

export default function SupUiLoading({ className = "", isSmall = false, svgClassName = "" }: SupUiLoadingProps) {
  return <SupLoader className={className} isSmall={isSmall} svgClassName={svgClassName} />;
}
